import { Typography } from '@mui/material';

export const FieldDesc = ({
  children,
  className,
  textClassName,
}: {
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
}) => {
  return (
    <div
      className={
        (textClassName ? 'mb-2 ' : 'opacity-50 mb-2 ') + (className ?? '')
      }
    >
      <Typography variant="body2" className={textClassName}>
        {children}{' '}
      </Typography>
    </div>
  );
};
